import { getLocalization } from '../localization/localizationService';

export const formatCurrency = (
  value: number | null | undefined = 0,
  currency: string | null | undefined
) => {
  const amount = value ?? 0;

  if (!currency) {
    return amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  return amount.toLocaleString(
    getLocalization().value.Locale.replace('_', '-'),
    {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    } as Intl.NumberFormatOptions
  );
};
